import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  TextField,
  Paper,
  Button,
  FormHelperText,
  Select,
  MenuItem,
  Tabs,
  Table,
  TableBody,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import * as Icons from '@material-ui/icons';
import ContentRow from './components/ContentRow';

const errRequired = 'required_field';
const errPassword = 'passwords_dont_match';
const errPasswordLength = 'password_length';
const errInvalidField = 'this_field_is_invalid';

class UsersPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      tabId: 0,
      expandAll: false,
      open: false,
      isDisabled: false,
      search: null,
      data: {
        username: '',
        password: '',
        confirmPassword: '',
        roleId: '',
        email: '',
        tel: '',
        locationId: '',
        firstName: '',
        lastName: '',
      },
      errorField: {
        username: {
          flag: false,
          msg: '',
        },
        password: {
          flag: false,
          msg: '',
        },
        confirmPassword: {
          flag: false,
          msg: '',
        },
        roleId: {
          flag: false,
          msg: '',
        },
        email: {
          flag: false,
          msg: '',
        },
        firstName: {
          flag: false,
          msg: '',
        },
        lastName: {
          flag: false,
          msg: '',
        },
      },
      errorReason: {
        reason: '',
      },
      loading: false,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, tenantIds } = this.props.user.toJS();
    await this.props.user.getUser(offset, limit, search, sort, order, tenantIds);
    await this.props.role.getRole(0, 0);
    // await this.props.locations.getLocationList(0,0);

    this.props.tenant.resetSelected();

    const tenantPermission = localStorage.getItem('tenant_permission')
      ? JSON.parse(localStorage.getItem('tenant_permission'))
      : [];
    await this.props.tenant.getTenants(0, 0, null, null, null, tenantPermission);

    this.initData(tenantPermission);
  }

  goBack() {
    this.props.user.setAction('action', true);
    this.props.history.goBack();
  }

  initData(tenantPermission) {
    const { users, loading, tenantIds } = this.props.user.toJS();
    let { tenants, selected } = this.props.tenant.toJS();

    const { id } = this.props.match.params;
    const userId = Number(id);
    const showData = users.data.find((item) => item.id === userId);
    // console.log('showData: ', showData)
    if (showData) {
      const locationPermission = showData.locationPermission ? JSON.parse(showData.locationPermission) : null;
      const tenantPermission = showData.tenantPermission ? JSON.parse(showData.tenantPermission) : null;
      const groupPermission = showData.groupPermission ? JSON.parse(showData.groupPermission) : null;
      const subgroupPermission = showData.subgroupPermission ? JSON.parse(showData.subgroupPermission) : null;

      this.setState({
        data: {
          id: showData.id,
          username: showData.userName,
          password: showData.password,
          confirmPassword: showData.password,
          roleId: showData.roleId,
          email: showData.email,
          tel: showData.tel,
          loading: loading,
          locationId: locationPermission[0],
          firstName: showData.firstName ?? '',
          lastName: showData.lastName ?? '',
        },
      });

      // expland row
      (tenants.data || []).forEach((t) => {
        if (tenantPermission && tenantPermission.includes(t.id)) {
          t.toggle = true;
        }
      });

      this.props.tenant.setData('tenants', tenants, false);
      this.onSearchChange(tenants);

      const selectedTenants = (tenants.data || []).filter(
        (t) => tenantPermission && (tenantPermission.length === 0 || tenantPermission.includes(t.id)),
      );
      (selectedTenants || []).forEach((t) => {
        const groups = (t.groups || [])
          .filter((g) => groupPermission && (groupPermission.length === 0 || groupPermission.includes(g.id)))
          .map((val) => {
            const subgroups = (val.subGroups || []).filter(
              (s) => subgroupPermission && (subgroupPermission.length === 0 || subgroupPermission.includes(s.id)),
            );
            if (subgroups.length > 0) {
              val.subGroups = subgroups;
            }
            return val;
          });
        selected.push({
          tenantId: t.id,
          groups,
          checked: true,
        });
      });

      this.props.tenant.setData('selected', selected, false);
    } else {
      // auto select tenant
      const Ids = tenantIds && tenantIds.length === 1 ? tenantIds : tenantPermission;
      if ((tenants && tenants.data && tenants.data.length === 1) || Ids.length === 1) {
        (tenants.data || [])
          .filter((t) => Ids.includes(t.id))
          .forEach((t) => {
            t.toggle = true;
            selected.push({
              tenantId: t.id,
              groups: t.groups,
              checked: true,
            });
          });

        this.props.tenant.setData('tenants', tenants, false);
        this.props.tenant.setData('selected', selected, false);
        this.onSearchChange(tenants);
      }
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleCreateUser = async (data) => {
    if (this.validate('create')) {
      const { t } = this.props;
      try {
        // const { tenants, selected } = this.props.tenant.toJS();
        // const tenantPermission = [];
        // const groupPermission = [];
        // const subgroupPermission = [];
        // (selected || []).forEach(val => {
        //   tenantPermission.push(val.tenantId);
        //   const foundTenant = (tenants.data || []).find(t => t.id === val.tenantId);
        //   if (foundTenant) {
        //     if (foundTenant.groups.length !== val.groups.length) {
        //       (val.groups || []).forEach(g => {
        //         groupPermission.push(g.id);
        //         const foundGroup = foundTenant.groups.find(group => group.id === g.id);
        //         if (foundGroup.subGroups.length !== g.subGroups.length) {
        //           (g.subGroups || []).forEach(subgroup => {
        //             subgroupPermission.push(subgroup.id);
        //           });
        //         }
        //       });
        //     }
        //   }
        // });

        if (!data.id) {
          const result = await this.props.user.createUser(data);
          if (result.statusCode === 200) {
            const perm = this.handlePermission();
            if (result.body) {
              this.setState({
                data: {
                  id: result.body.id,
                  username: result.body.userName,
                  roleId: result.body.roleId,
                  email: result.body.email,
                  tel: result.body.tel,
                  locationPermission: perm.locationPermission,
                  tenantPermission: perm.tenantPermission,
                  groupPermission: perm.groupPermission,
                  subgroupPermission: perm.subgroupPermission,
                  firstName: result.body.firstName,
                  lastName: result.body.lastName,
                },
              });
            }
            await this.props.user.updateUser(this.state.data);

            setTimeout(() => {
              this.props.history.push('../users');
            }, 100);
          }
        } else {
          await this.props.user.updateUser(this.state.data);

          setTimeout(() => {
            this.props.history.push('../users');
          }, 100);
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = t(e.error.message) || 'Failed to Create!';
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
        //เพิ่ม status code และ msg ใน i18
      }
    }
  };

  handleEditUser(data) {
    if (this.validate('edit')) {
      const { t } = this.props;
      Swal.fire({
        html: `<h4>${t('edit_user')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const perm = this.handlePermission();
            data.locationPermission = perm.locationPermission;
            data.tenantPermission = perm.tenantPermission;
            data.groupPermission = perm.groupPermission;
            data.subgroupPermission = perm.subgroupPermission;
            // console.log('data: ', data)
            const result = await this.props.user.updateUser(data);
            if (result.statusCode === 200) {
              this.props.user.setAction('action', true);
              this.props.history.push('../../users');
              // Swal.fire({ html: `<h4>${t('update_success')}`, type: "success" }).then(async resultSuccess => {
              //   if (resultSuccess.value) {
              //     this.props.user.setAction('action', true);
              //     this.props.history.push('../../users')
              //   } else {
              //     Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: "error" });
              //   }
              // });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else if (e.statusCode === 400) {
              const msg = e.error.message || 'Failed to Update';
              Swal.fire({ html: `<h4>${msg}`, type: 'error' });
            } else {
              Swal.fire({
                html: `<h4>${t('failed_to_update')}`,
                type: 'error',
              });
            }
          }
        }
      });
    }
    // this.props.user.updateUser(data)
  }

  handlePermission() {
    const { tenants, selected } = this.props.tenant.toJS();
    // console.log('selected: ', selected);
    const tenantPermission = [];
    const groupPermission = [];
    const subgroupPermission = [];
    const locationPermission = [];
    (selected || []).forEach((val) => {
      tenantPermission.push(val.tenantId);
      const foundTenant = (tenants.data || []).find((t) => t.id === val.tenantId);
      if (foundTenant) {
        if (!locationPermission.includes(foundTenant.locationId)) {
          locationPermission.push(foundTenant.locationId);
        }
        (val.groups || []).forEach((g) => {
          groupPermission.push(g.id);
          const foundGroup = foundTenant.groups.find((group) => group.id === g.id);
          if (foundGroup.subGroups.length !== g.subGroups.length) {
            (g.subGroups || []).forEach((subgroup) => {
              subgroupPermission.push(subgroup.id);
            });
          }
          // if (foundTenant.groups.length !== val.groups.length) {
          //   groupPermission.push(g.id);
          // }
          // const foundGroup = foundTenant.groups.find(group => group.id === g.id);
          // if (foundGroup.subGroups.length !== g.subGroups.length) {
          //   (g.subGroups || []).forEach(subgroup => {
          //     subgroupPermission.push(subgroup.id);
          //   });
          // }
        });
      }
    });

    return {
      locationPermission,
      tenantPermission,
      groupPermission,
      subgroupPermission,
    };
  }

  validatePasswordLength(password) {
    if (password.length < 6) {
      return { flag: true, msg: errPasswordLength };
    }
    return { flag: false, msg: '' };
  }

  validatePassword(password, confirmPassword) {
    if (!confirmPassword) {
      return { flag: true, msg: errRequired };
    } else {
      if (confirmPassword.length < 6) {
        return { flag: true, msg: errPasswordLength };
      } else {
        if (password && password !== confirmPassword) {
          return { flag: true, msg: errPassword };
        }
      }
    }
    return { flag: false, msg: '' };
  }

  validateEmail(email) {
    if (!email) return { flag: false, msg: '' };
    const regx = new RegExp(
      '^(([^<>()[\\]\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    );
    return regx.test(email) ? { flag: false, msg: '' } : { flag: true, msg: errInvalidField };
  }

  validate(mode) {
    const { data } = this.state;
    let checkUserName = !data.username ? true : false;
    let checkRole = !data.roleId ? true : false;
    let email = this.validateEmail(data.email);
    let checkPass = { flag: false, msg: '' };
    let confirmPassword = { flag: false, msg: '' };
    if (mode === 'create') {
      checkPass = !data.password ? { flag: true, msg: errRequired } : this.validatePasswordLength(data.password);
      confirmPassword = this.validatePassword(data.password, data.confirmPassword);
    }
    this.setState({
      errorField: {
        username: {
          flag: checkUserName,
          msg: errRequired,
        },
        roleId: {
          flag: checkRole,
          msg: errRequired,
        },
        password: checkPass,
        confirmPassword,
        email,
      },
    });

    return !(checkUserName || checkPass.flag || confirmPassword.flag || email.flag || checkRole);
    // } else {
    //   if (data.password !== data.confirmPassword) {
    //     this.setState({
    //       errorField: {
    //         confirmPassword: true,
    //       },
    //       errorReason: {
    //         reason: "Passwords don't match",
    //       }
    //     })
    //     return false;
    //   } else {
    //     this.setState({
    //       errorField: {
    //         username: false,
    //         password: false,
    //         confirmPassword: false
    //       }
    //     });
    //   }
    // }
    // return true;
  }

  clearErrorField(key) {
    if (key === 'username') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          username: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'password') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          password: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'confirmPassword') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          confirmPassword: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'roleId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          roleId: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'email') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          email: {
            flag: false,
            msg: '',
          },
        },
      });
    }
  }

  onStep = (tabId, task) => {
    if (this.validate(task)) {
      this.setState({ tabId });
    }
  };

  handleTabChange = (value, task) => {
    if (this.validate(task)) {
      this.setState({ tabId: value });
    }
  };

  handleSelectAllTenant = (e) => {
    const { checked } = e.target;
    const selected = [];
    const { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      // set expland row
      t.toggle = t.groups.length > 0 ? checked : false;

      // select all tenants
      if (checked) {
        selected.push({
          tenantId: t.id,
          groups: t.groups,
          checked: true,
        });
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);
    this.props.tenant.setData('selected', selected, false);
  };

  handleChangeTenant = (e) => {
    const { value, checked } = e.target;

    // set expland row
    let { tenants, selected } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (t.id === +value) {
        t.toggle = t.groups.length > 0 ? checked : false;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);

    // selected  tenant
    if (checked) {
      (tenants.data || []).forEach((t) => {
        if (t.id === +value) {
          selected.push({
            tenantId: t.id,
            groups: t.groups,
            checked: true,
          });
        }
      });
    } else {
      selected = (selected || []).filter((s) => s.tenantId !== +value);
    }

    this.props.tenant.setData('selected', selected, false);
  };

  handleChangeSearch = (event) => {
    const { value } = event.target;
    const { tenants } = this.props.tenant.toJS();

    this.props.tenant.setSearch(value);
    this.onSearchChange(tenants);
  };

  onSearchChange = (tenants) => {
    const { searchText } = this.props.tenant.toJS();
    const search = searchText && searchText.toLowerCase();
    let searchResult = tenants;
    if (search && search.length > 0) {
      const tmp = (tenants.data || []).filter((tenant) => {
        if (tenant.name.toLowerCase().includes(search)) {
          return true;
        } else if (tenant.groups && tenant.groups.length > 0) {
          const found = tenant.groups.find((group) => {
            if (group.name.toLowerCase().includes(search)) {
              return true;
            } else if (group.subGroups && group.subGroups.length > 0) {
              return group.subGroups.find((subgroup) => subgroup.name.toLowerCase().includes(search));
            }
            return false;
          });
          return found;
        }
        return false;
      });

      searchResult = { data: tmp };
    }

    this.props.tenant.setData('displayedTenants', searchResult, false);
  };

  handleToggle = (id) => {
    let { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (t.id === id) {
        t.toggle = !t.toggle;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);
  };

  handleExpandAll = (task) => {
    let { tenants } = this.props.tenant.toJS();
    (tenants.data || []).forEach((t) => {
      if (task === 'expand-all') {
        t.toggle = true;
      }
      if (task === 'collapse-all') {
        t.toggle = false;
      }
    });
    this.props.tenant.setData('tenants', tenants, false);
    this.onSearchChange(tenants);
  };

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, tabId, isDisabled } = this.state;
    const { roles } = this.props.role.toJS();
    // const { locations } = this.props.locations.toJS();
    const { displayedTenants, searchText, selected } = this.props.tenant.toJS();
    const expands = (displayedTenants.data || []).filter((t) => t.toggle);
    const expandAll = expands.length === (displayedTenants.data || []).length;
    // console.log('displayedTenants: ', displayedTenants.data )
    const isSelectAllTenants =
      displayedTenants.data && displayedTenants.data.length > 0 && displayedTenants.data.length === selected.length;
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_new_user')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0, 'create')}
              >
                {t('user_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1, 'create')}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>

          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('username')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='username'
                  name='username'
                  fullWidth
                  value={data.username}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/, '');
                  }}
                  error={!data.reset ? this.state.errorField.username.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.username.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.username.msg}`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('password')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='password'
                  name='password'
                  type='password'
                  fullWidth
                  value={data.password}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  inputProps={{
                    autoComplete: 'new-password',
                  }}
                  error={!data.reset ? this.state.errorField.password.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.password.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.password.msg}`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('confirm_password')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='confirmPassword'
                  name='confirmPassword'
                  type='password'
                  fullWidth
                  value={data.confirmPassword}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.confirmPassword.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.confirmPassword.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.confirmPassword.msg}`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('role')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.roleId || 0}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'roleId',
                      id: 'roleId',
                    }}
                  >
                    <MenuItem fullwidth='true' key={9999999} value={0}>
                      {t('please_select_role')}
                    </MenuItem>
                    {(roles.data || []).map((val) => (
                      <MenuItem
                        fullwidth='true'
                        key={val.id}
                        value={val.id}
                        disabled={val.id === 1 && localStorage.getItem('role_id') !== '1' ? true : false}
                      >
                        {`${val.name || 'role name'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.roleId.flag : true}
                  id='  component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('first_name')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='firstName'
                  name='firstName'
                  fullWidth
                  value={data.firstName}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('last_name')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='lastName'
                  name='lastName'
                  fullWidth
                  value={data.lastName}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('email')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='email'
                  name='email'
                  fullWidth
                  value={data.email}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.email.flag : false}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/, '');
                  }}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.email.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.email.msg}`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('tel')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='tel'
                  name='tel'
                  fullWidth
                  value={data.tel}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 10 }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.button}
                    onClick={() => this.onStep(1, 'edit')}
                  >
                    {t('next')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              {/* <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} />
            </Grid> */}
              {/* <Grid item xs={12} sm={6}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId || 0}
                  // onChange={this.handleChangeLocations}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  <MenuItem fullwidth="true" key={0} value={0}>
                    {t('please_select_location')}
                  </MenuItem>
                  {(locations.data || []).map(val => (
                    <MenuItem fullwidth="true" key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid> */}

              <Grid container item xs={6} sm={6}>
                <TextField
                  required
                  id='search'
                  name='search'
                  fullWidth
                  value={searchText || ''}
                  onChange={(e) => this.handleChangeSearch(e)}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('search')}
                />
              </Grid>

              <Grid container item xs={12} sm={12}>
                <Grid container item xs={6} sm={6} alignItems='flex-end'>
                  <FormControlLabel
                    style={{ marginLeft: 12 }}
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                    control={
                      <Checkbox
                        id='selectAll'
                        color='primary'
                        edge='start'
                        onChange={(e) => this.handleSelectAllTenant(e)}
                        checked={isSelectAllTenants ? true : false}
                        indeterminate={selected.length === 0 || isSelectAllTenants ? false : true}
                        indeterminateIcon={<Icons.IndeterminateCheckBox color='primary' />}
                        inputProps={{
                          'aria-label': 'checkbox-list-label-all',
                        }}
                      />
                    }
                    label={t('select_all_tenants')}
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('collapse-all')}>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('expand-all')}>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={isDisabled}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.handleCreateUser(data)}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, loading, tabId, isDisabled } = this.state;
    const { roles } = this.props.role.toJS();
    const { displayedTenants, searchText, selected } = this.props.tenant.toJS();
    const expands = (displayedTenants.data || []).filter((t) => t.toggle);
    const expandAll = expands.length === (displayedTenants.data || []).length;
    const isSelectAllTenants =
      displayedTenants.data && displayedTenants.data.length > 0 && displayedTenants.data.length === selected.length;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_user')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0)}
              >
                {t('user_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1)}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>

          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('username')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='username'
                  name='username'
                  fullWidth
                  value={data.username}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  disabled
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/, '');
                  }}
                  error={!data.reset ? this.state.errorField.username.flag : false}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.username.flag : true}
                  id='component-error-text'
                >
                  {t(`${this.state.errorField.username.msg}`)}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('first_name')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='firstName'
                  name='firstName'
                  fullWidth
                  value={data.firstName}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('last_name')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='lastName'
                  name='lastName'
                  fullWidth
                  value={data.lastName}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('role')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.roleId || 0}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'roleId',
                      id: 'roleId',
                    }}
                  >
                    <MenuItem fullwidth='true' key={9999999} value={0}>
                      {t('please_select_role')}
                    </MenuItem>
                    {(roles.data || []).map((val) => (
                      <MenuItem
                        fullwidth='true'
                        key={val.id}
                        value={val.id}
                        disabled={val.id === 1 && localStorage.getItem('role_id') !== '1' ? true : false}
                      >
                        {`${val.name || 'role name'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.roleId.flag : true}
                  id='  component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('email')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='email'
                  name='email'
                  fullWidth
                  value={data.email}
                  onChange={this.handleChange}
                  variant='outlined'
                  margin='dense'
                  error={!data.reset ? this.state.errorField.email.flag : false}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[ก-๙]/g, '');
                  }}
                />
                <FormHelperText
                  error
                  hidden={!data.reset ? !this.state.errorField.email.flag : true}
                  id='component-error-text'
                >
                  {this.state.errorField.email.msg}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('tel')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='tel'
                  name='tel'
                  fullWidth
                  value={data.tel}
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 10 }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  variant='outlined'
                  margin='dense'
                />
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.button}
                    onClick={() => this.onStep(1, 'edit')}
                  >
                    {t('next')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid container item xs={6} sm={6}>
                <TextField
                  required
                  id='search'
                  name='search'
                  fullWidth
                  value={searchText || ''}
                  onChange={(e) => this.handleChangeSearch(e)}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('search')}
                />
              </Grid>

              <Grid container item xs={12} sm={12}>
                <Grid container item xs={6} sm={6} alignItems='flex-end'>
                  <FormControlLabel
                    style={{ marginLeft: 12 }}
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                    control={
                      <Checkbox
                        id='selectAll'
                        color='primary'
                        edge='start'
                        onChange={(e) => this.handleSelectAllTenant(e)}
                        checked={isSelectAllTenants ? true : false}
                        indeterminate={selected.length === 0 || isSelectAllTenants ? false : true}
                        indeterminateIcon={<Icons.IndeterminateCheckBox color='primary' />}
                        inputProps={{
                          'aria-label': 'checkbox-list-label-all',
                        }}
                      />
                    }
                    label={t('select_all_tenants')}
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('collapse-all')}>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('expand-all')}>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={isDisabled}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.handleEditUser(data)}
                    className={classes.button}
                  >
                    {t('save')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  renderFormView() {
    const { classes, t } = this.props;
    const { data, loading, tabId } = this.state;
    const { roles } = this.props.role.toJS();
    const { displayedTenants, searchText, selected } = this.props.tenant.toJS();
    const expands = (displayedTenants.data || []).filter((t) => t.toggle);
    const expandAll = expands.length === (displayedTenants.data || []).length;
    const isSelectAllTenants =
      displayedTenants.data && displayedTenants.data.length > 0 && displayedTenants.data.length === selected.length;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_user')} />
          <Grid style={{ marginTop: 15 }}>
            <Tabs
              value={tabId}
              name='tab'
              TabIndicatorProps={{
                style: {
                  display: 'none',
                },
              }}
            >
              <Button
                id='0'
                className={tabId === 0 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(0)}
              >
                {t('user_info')}
              </Button>
              <Button
                id='1'
                className={tabId === 1 ? classes.tabsActive : classes.tabs}
                onClick={() => this.handleTabChange(1)}
              >
                {t('permission')}
              </Button>
            </Tabs>
          </Grid>

          {tabId === 0 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('username')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='username'
                  name='username'
                  fullWidth
                  value={data.username}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('role')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.roleId || 0}
                    inputProps={{
                      name: 'roleId',
                      id: 'roleId',
                    }}
                    disabled
                  >
                    <MenuItem fullwidth='true' key={9999999} value={0}>
                      {t('please_select_role')}
                    </MenuItem>
                    {(roles.data || []).map((val) => (
                      <MenuItem
                        fullwidth='true'
                        key={val.id}
                        value={val.id}
                        disabled={val.id === 1 && localStorage.getItem('role_id') !== '1' ? true : false}
                      >
                        {`${val.name || 'role name'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('email')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='email'
                  name='email'
                  fullWidth
                  value={data.email}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('tel')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField id='tel' name='tel' fullWidth value={data.tel} variant='outlined' margin='dense' disabled />
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={this.goBack}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button
                    variant='contained'
                    color='primary'
                    className={classes.button}
                    onClick={() => this.onStep(1, 'edit')}
                  >
                    {t('next')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          {tabId === 1 && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid container item xs={6} sm={6}>
                <TextField
                  required
                  id='search'
                  name='search'
                  fullWidth
                  value={searchText || ''}
                  onChange={(e) => this.handleChangeSearch(e)}
                  inputProps={{ maxLength: 255 }}
                  variant='outlined'
                  margin='dense'
                  placeholder={t('search')}
                />
              </Grid>

              <Grid container item xs={12} sm={12}>
                <Grid container item xs={6} sm={6} alignItems='flex-end'>
                  <FormControlLabel
                    style={{ marginLeft: 12 }}
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                    control={
                      <Checkbox
                        id='selectAll'
                        color='primary'
                        edge='start'
                        onChange={(e) => this.handleSelectAllTenant(e)}
                        checked={isSelectAllTenants ? true : false}
                        indeterminate={selected.length === 0 || isSelectAllTenants ? false : true}
                        indeterminateIcon={<Icons.IndeterminateCheckBox color='primary' />}
                        inputProps={{
                          'aria-label': 'checkbox-list-label-all',
                        }}
                        disabled
                      />
                    }
                    label={t('select_all_tenants')}
                  />
                </Grid>
                <Grid container item xs={6} sm={6} justify='flex-end'>
                  {expandAll ? (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('collapse-all')}>
                      <Icons.ExpandLess />
                      {t('collapse_all')}
                    </Button>
                  ) : (
                    <Button className={classes.btnExpand} onClick={() => this.handleExpandAll('expand-all')}>
                      <Icons.ExpandMore />
                      {t('expand_all')}
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Table>
                  <TableBody>
                    {(displayedTenants.data || []).map((row) => (
                      <ContentRow
                        row={row}
                        key={row.id}
                        data={data}
                        handleChangeTenant={this.handleChangeTenant}
                        handleToggle={this.handleToggle}
                        disabled={true}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Grid>

              <Grid container item xs={12}>
                <Grid container item xs={6} justify='flex-start'>
                  <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.onStep(0)}>
                    {t('back')}
                  </Button>
                </Grid>
                <Grid container item xs={6} justify='flex-end'>
                  <Button variant='contained' color='primary' onClick={() => this.goBack()} className={classes.button}>
                    {t('cancel')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/users/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderFormView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '9px',
    height: 49,
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
  tabs: {
    width: '48%',
    color: theme.palette.text.secondary,
    fontWeight: 400,
    borderBottom: `3px solid ${theme.palette.text.hint}`,
    borderRadius: 0,
    margin: 4,
  },
  tabsActive: {
    width: '48%',
    color: theme.palette.primary.main,
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
    margin: 4,
  },
  btnExpand: {
    width: '150px',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
});
export const page = inject('user', 'role', 'tenant', 'locations')(observer(UsersPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
